import { useEffect, useState } from "react";
import { Quote, Star } from "lucide-react";
import api from "@/lib/api";

export default function Testimonials() {
    const [items, setItems] = useState([]);
    useEffect(() => {
        api.get("/testimonials").then((r) => setItems(r.data)).catch(() => {});
    }, []);
    if (!items.length) return null;

    return (
        <section className="section bg-[#f8f9fa]" data-testid="testimonials-section">
            <div className="container-x">
                <div className="max-w-[680px]">
                    <p className="eyebrow">Patient Stories</p>
                    <h2 className="font-serif text-[40px] md:text-[56px] leading-[1.04] mt-3">
                        Real Indians. <span className="italic text-[#003E4D]">Real clarity.</span>
                    </h2>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-12">
                    {items.map((t) => (
                        <article key={t.id} className="bg-white rounded-3xl p-8 border border-black/5" data-testid={`testimonial-${t.id}`}>
                            <Quote size={26} className="text-[#003E4D] opacity-40" />
                            <p className="mt-4 text-[16px] leading-relaxed text-[#1a1a1a] font-serif italic">"{t.text}"</p>
                            <div className="mt-6 flex items-center gap-3">
                                <div className="w-10 h-10 rounded-full bg-[#003E4D] text-white flex items-center justify-center font-semibold text-[15px]">
                                    {t.name.charAt(0)}
                                </div>
                                <div>
                                    <p className="font-semibold text-[14px]">{t.name}</p>
                                    <p className="text-[12px] text-[#4a5568]">{t.city}</p>
                                </div>
                                <div className="ml-auto flex">
                                    {Array.from({ length: t.rating || 5 }).map((_, i) => (
                                        <Star key={i} size={12} className="text-[#f5a623] fill-[#f5a623]" />
                                    ))}
                                </div>
                            </div>
                        </article>
                    ))}
                </div>
            </div>
        </section>
    );
}
